var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.053 3.145A7.5 7.5 0 1 0 17.5 10v-.767a.833.833 0 1 1 1.667 0V10a9.168 9.168 0 1 1-5.436-8.378.833.833 0 1 1-.678 1.523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.922 2.744a.833.833 0 0 1 0 1.178l-8.332 8.342a.833.833 0 0 1-1.18 0l-2.5-2.5a.833.833 0 0 1 1.18-1.178l1.91 1.91 7.744-7.752a.833.833 0 0 1 1.178 0"
  }))));
};
export default SvgCheckCircle;